import React from 'react';
import { Link } from 'react-router-dom';

export const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/app-logo.png" alt="" width={40} height={40} className="logo-mark" />
            <span className="logo-text">Good Old Maps</span>
          </Link>
          <nav className="nav">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/terms" className="nav-link">Legal</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};



































